<div class="adressesResponse" *ngIf="response && response.length == 1 ">

    <p class="postOfficeIndex" *ngIf=" ! isPVPZ( response[0].TYPE_ACRONYM ) && ! isSVPZ( response[0].TYPE_ACRONYM) && ! isMVPZ( response[0].TYPE_ACRONYM ) ">{{ response[0].POSTCODE }}</p>
    <p class="postOfficeIndex" *ngIf="isPVPZ( response[0].TYPE_ACRONYM ) || isSVPZ( response[0].TYPE_ACRONYM) || isMVPZ( response[0].TYPE_ACRONYM ) ">{{ response[0].POSTCODE }}</p>

    <p class="postOfficeField">{{ response[0].TYPE_SHORT }}.</p>
    <p class="postOfficeField" *ngIf=" response[0].TYPE_ACRONYM && response[0].PO_SHORT "><span *ngIf="! isContainsPostOfficeType( response[0].PO_SHORT )">{{ response[0].TYPE_ACRONYM }}</span> {{ response[0].PO_SHORT }}.</p>
    <p class="postOfficeField" *ngIf=" response[0].LOCK_UA &&  response[0].LOCK_UA != 'Активний запис'">{{ response[0].LOCK_UA }}.</p>
    <p class="postOfficeField" *ngIf=" response[0].NOTES_UA && isString(response[0].NOTES_UA) ">{{ response[0].NOTES_UA}}</p>

    <hr *ngIf="response">
    <p class="OfficeInfo">
        <img *ngIf="! isPVPZ( response[0].TYPE_ACRONYM ) " class="OfficeInfoIcon" src="url(../../assets/pin.svg" />
        <span *ngIf="! isPVPZ( response[0].TYPE_ACRONYM ) ">{{ response[0].ADDRESS }}, </span>
        <span *ngIf="! isPVPZ( response[0].TYPE_ACRONYM ) ">{{ response[0].SHORTCITYTYPE_UA}}. {{response[0].CITY_UA }}, <span *ngIf=" ! isDistrictCenter( response[0].DISTRICT_UA )">{{ response[0].DISTRICT_UA }} р-н.,</span> {{ response[0].REGION_UA }}
        обл.</span>

    </p>
    <p class="OfficeInfo"><img class="OfficeInfoIcon" src="url(../../assets/email.png" /><a href="mailto:ukrposhta@ukrposhta.ua">ukrposhta@ukrposhta.ua</a></p>
    <p class="" *ngIf="response[0].AVALIBLE == 0 ">УВАГА! ВПЗ працює автономно. (Надання послуг поштового зв’язку можливо лише у межах території обслуговування ВПЗ)</p>

    <ng-container *ngFor="let period of schedule">
        <div class="group">
          <img class="OfficeInfoIcon" src="url(../../assets/clock.svg" />
          <b><span>{{ period[0] }}</span></b> 
          <ng-container *ngFor="let day of period[1]; let i = index">
            <p class="OfficeInfo">
              <span class="space" *ngIf="i >= 0"></span>
              <span>{{ day.DAYOFWEEK_UA }} </span>
              <span>{{ day.TFROM }} - </span>
              <span>{{ day.TTO }}</span>
            </p>
          </ng-container>
          <br>
        </div>
      </ng-container>

</div>







<div class="adressesResponse" *ngIf="response && response.length > 1">
    <p class="postOfficeIndex">{{ response[0].POSTINDEX }}</p>
    <p class="postOfficeField">{{ response[0].CITYTYPE_UA }} {{ response[0].CITY_UA }}.</p>

    <ng-container *ngFor="let office of response ">

        <hr>
        <p class="OfficeInfo">{{office.TYPE_SHORT}}</p>
        <p class="OfficeInfo">{{office.PO_SHORT}}</p>
        <p class="OfficeInfo" *ngIf="! isPVPZ( office.TYPE_ACRONYM )"><img class="OfficeInfoIcon" src="url(../../assets/pin.svg" />{{office.ADDRESS}}</p>
        <p class="OfficeInfo"><img class="OfficeInfoIcon" src="url(../../assets/email.png" /><a href="mailto:ukrposhta@ukrposhta.ua">ukrposhta@ukrposhta.ua</a></p>
        <!-- <p class="" *ngIf="response[0].AVALIBLE === '0' ">УВАГА! ВПЗ працює автономно. (Надання послуг поштового зв’язку можливо лише у межах території обслуговування ВПЗ)</p> -->
        
        <ng-container *ngFor="let day of office.scadule; let i = index">
            <p class="OfficeInfo">
                <img class="OfficeInfoIcon" *ngIf="i==0" src="url(../../assets/clock.svg" />
                <span class="space" *ngIf="i > 0"></span><span>{{day.DAYOFWEEK_UA}} </span><span>{{day.TFROM}} - </span><span>{{day.TTO}}</span>
            </p>
        </ng-container>
    </ng-container>
</div>

<div id="map" *ngIf="isShowMap && response && response[0] && response[0].LATTITUDE && response[0].LONGITUDE " class="map margin-top-20" leaflet [leafletOptions]="options" [leafletLayers]="layers" (leafletMapReady)="onMapReady($event)">
</div>

<!-- Error display 
<div class=" adressesResponse" *ngIf="isResponseError" >
    
  <p class="postOfficeIndex"> Сталася помилка.</p>

  <p class="postOfficeField"  > Перевірте правильність даних. </p>
  
  <hr>

</div>
-->